import {arrayRemove, arrayUnion, doc, getFirestore, updateDoc} from "firebase/firestore";

const ChatArchive=async (chatId:string,userId:string,_archive:boolean=true)=>{
    return updateDoc(doc(getFirestore(),'chats',chatId),{archivedBy: _archive?arrayUnion(userId):arrayRemove(userId)})
}
export default ChatArchive;